/* 
DB calls and Dependencies
*/
import * as service from "./ProjectionCard.service.js";
import { mapGetters } from "vuex";
import * as reportService from "../../../Service/Report.service";
import { formatDate } from "../../../Utility/commonUtilities";

// Dynamic Components
import pieChart from "../../Chart1/PieChart/PieChart";
import clusteredbarchart from "../../Chart1/ClusteredBarchart/ClusteredBarChart";
import groupedpiechart from "../../Chart1/GroupedPieChart/GroupedPieChart.vue";
import dataTableComponent from "../../Chart1/DataTableComponent/DataTableComponent.vue";

// import SeaCargo from "../SeaCargo/SeaCargo";

/* 
Logic for the Projection Card and the pop-ups for each projection card
*/
export default {
  name: "ProjectionCard",
  props: ["card", "apiFilterParams"],
  components: {
    pieChart,
    clusteredbarchart,
    groupedpiechart,
    dataTableComponent,
  },

  data() {
    return {
      toggleDrillDownPopup: false,
      componentData: {},
      alert: true,
      showParamerterPopup: false,
      reportParameters: [],
      hideVtabSlider: true,
      showFirstTab: false,
    };
  },

  async mounted() {},

  computed: {
    ...mapGetters([
      "getSelectedArea",
      "getSelectedTeam",
      "getSelectedBranch",
      "getFilterPeriod",
      "getFinancialYear",
      "getActiveReportMenu",
      "getCurrentFilters",
      "getSelectedGroupBy",
    ]),
  },

  methods: {
    setHeightCanvas(index, componentName) {
      if (componentName == "clusteredbarchart") {
        var parentElememt = document.getElementById("component" + index);
        var canvasElement = parentElememt.getElementsByTagName("canvas");
        if (canvasElement && canvasElement.length > 0) {
          canvasElement[0].style.height = "400px";
        }
      }
    },

    closeParameterPoup() {
      this.showParamerterPopup = false;
      this.reportParameters = [];
    },

    setParameter() {
      var parameters = {};

      this.reportParameters.forEach((Parameter) => {
        var valueField = "";
        if (Parameter.type.includes("date")) {
          valueField = new Date(Parameter["value"]);
          //.toLocaleDateString()
        } else {
          valueField = Parameter["value"];
        }
        parameters[Parameter["name"]] = valueField;
      });
      this.showParamerterPopup = false;
      this.redirectToTelerikReport(parameters);
    },

    redirectToTelerikReport(parameters = {}) {
      // var groupedreports = {
      //   component: "groupedReport",
      //   groupTitle: "Courier Future",
      //   overrideParameters: false,
      //   data_source: [
      //     { title: "OVERTIME", url: "Samples/cou_future" },
      //     { title: "PayRoll", data_source: "Samples/payroll" }
      //   ],
      //   data_parameters: []
      // };

      // var singleReport = {
      //   component: "report",
      //   overrideParameters: true,
      //   data_source: { title: "PayRoll", url: "Samples/payroll" },
      //   data_parameters: []
      // };

      // this.card.DrillDown_Details[0] = groupedreports;

      var routeObj = {
        name: `${this.card.Title} ${this.card.Icon_Title}`,
        params: {
          parameter: parameters,
          groupTitle: this.card.DrillDown_Details[0].title
            ? this.card.DrillDown_Details[0].title
            : "",
          isGrouped: this.card.DrillDown_Details[0].component
            .toLowerCase()
            .includes("groupedreport"),
          reports: this.card.DrillDown_Details[0].data_source,
          overrideParameters: this.card.DrillDown_Details[0].hideParameters
            ? this.card.DrillDown_Details[0].hideParameters
            : false,

          // currentReport: {},
        },
      };

      this.$router.app.$emit("onTelerikReportDrillDown", routeObj);
      // this.$router.push(routeObj);

      // let routeData = this.$router.resolve(routeObj);
      // localStorage.setItem(
      //   "telerikParameters",
      //   JSON.stringify(routeObj.params)
      // );
      // window.open(routeData.href, "_blank");
    },

    processReportCard(dataParameters) {
      if (dataParameters && dataParameters.length > 0) {
        var parameters = JSON.parse(
          JSON.stringify(dataParameters).toLowerCase()
        );

        parameters.forEach((param, index) => {
          param["menu" + index] = "";
          param.label =
            param.label.charAt(0).toUpperCase() + param.label.slice(1);
          param.value = "";
          if (param.name.includes("office") || param.name.includes("branch")) {
            param.value = this.getSelectedBranch.Office
              ? this.getSelectedBranch.Office
              : 0;
          } else if (param.name.includes("team")) {
            param.value = this.getSelectedTeam.Team
              ? this.getSelectedTeam.Team
              : 0;
          } else if (param.name.includes("area")) {
            param.value = this.getSelectedArea.Area
              ? this.getSelectedArea.Area
              : 0;
          } else if (param.type == "date") {
            param.value = formatDate(new Date().toLocaleDateString());
          }
        });

        if (parameters.filter((x) => x.iseditable == true).length == 0) {
          this.reportParameters = parameters;
          this.setParameter();
        } else {
          this.showParamerterPopup = true;
          this.reportParameters = parameters;
        }
      } else {
        this.redirectToTelerikReport();
      }
    },

    async getDrillDownDetails() {
      if (this.card.IsReportType && this.card.DrillDown_Details) {
        this.processReportCard(this.card.DrillDown_Details[0].data_parameters);
      } else {
        this.componentData = {};
        let context = this;
        this.toggleDrillDownPopup = true;

        if (
          this.card.DrillDown_Details &&
          this.card.DrillDown_Details.length > 0 &&
          !this.card.IsReportType
        ) {
          let i = 0;
          for (i = 0; i < this.card.DrillDown_Details.length; i++) {
            this.$set(
              this.componentData,
              this.card.DrillDown_Details[i].title,
              null
            );
          }

          // context.componentData[context.card.DrillDown_Details[0].title] = await context.fetchChartData(context.card.DrillDown_Details[0].data_source);
        }
      }
    },

    async onTabSwitch(index, title, componentName, data_source) {
      let context = this;
      this.hideVtabSlider = false;

      if (!context.componentData[title]) {
        context.componentData[title] = await context.fetchChartData(
          data_source
        );
      }
      context.$nextTick(() => {
        context.setHeightCanvas(index, componentName);
      });
    },
    // Fetches data for the chart : procedure name passed as argument

    async fetchChartData(procedureName) {
      let context = this;
      var result = await reportService.getTilesByProcedureName(
        this.getSelectedArea.Area,
        this.getSelectedTeam.Team,
        this.getSelectedBranch.Office,
        this.getCurrentFilters.CurrentYear,
        this.getCurrentFilters.Month,
        procedureName,
        this.getSelectedGroupBy
      );

      if (result.error == false && result.data.Table.length > 0) {
        return result.data.Table;
      }

      return [];
    },

    getAlertMessageChart(chartData, type) {
      // Sales or Units
      type = type.toLocaleLowerCase();

      if (chartData && chartData.length == 3) {
        var budget = chartData[2].value;
        var current = chartData[1].value;
        // var currentDate = new Date('2020', '1', 12);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate
          .toLocaleString("default", { month: "short" })
          .toUpperCase();

        if (current > budget) {
          var exceededValue = type.includes("units")
            ? current - budget + " Units"
            : "$" + (current - budget).toLocaleString();
          var increasedValue = current - budget;
          var percentageIncrease = ((increasedValue / budget) * 100).toFixed(2);
          exceededValue =
            exceededValue + " (" + percentageIncrease + "% Increase)";
          return (
            "Congratulations!! You have exceeded your budget by " +
            exceededValue +
            "."
          );
        } else {
          /* #region  Warning message for current month */
          var targetToAchieve = type.includes("units")
            ? budget - current + " Units"
            : "$" + (budget - current).toLocaleString();

          if (
            currentYear == chartData[1].myear &&
            currentMonth == chartData[1].label.toUpperCase() &&
            type.includes("mtd") == false
          ) {
            var currentDay = currentDate.getDate();
            var daysinCurrentMonth = new Date(
              currentYear,
              currentDate.getMonth() + 1,
              0
            ).getDate();
            var remainingDays = daysinCurrentMonth - currentDay;

            var remainingDayMessage = "";
            if (remainingDays == 1) {
              remainingDayMessage = "1 day to go, ";
            } else if (remainingDays == 0) {
              remainingDayMessage = "Last Day, ";
            } else {
              remainingDayMessage = remainingDays + " days to go, ";
            }
            return (
              remainingDayMessage +
              targetToAchieve +
              " needed to achieve Budget."
            );
          } else {
            /* #endregion */
            return targetToAchieve + " needed to achieve Budget.";
          }
        }
      }
      return "";
    },
    /* #region -Show Alert Type : ie success/error-  */
    getAlertType(chartData) {
      if (chartData && chartData.length == 3) {
        var budget = chartData[2].value;
        var current = chartData[1].value;

        return budget > current ? "error" : "success";
      }
      return "success";
    },
    /* #endregion */
  },
};
